import axios from 'axios'
import {ResponseObjectPaginated} from '../../../../../models'
import {FurnitureModel, GetPaginationFurnitureDto} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function getFurnitureService(dto: GetPaginationFurnitureDto) {
  return axios.post<ResponseObjectPaginated<FurnitureModel[]>>(`${BASEURL}/furniture/getList`, dto)
}
